export default __webpack_public_path__ + "static/media/rainy_day.7af55191.jpg";